import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from '@mui/material/styles';
import { Grid, Typography } from '@mui/material';
import LinearProgress, { linearProgressClasses } from '@mui/material/LinearProgress';
const calculatePercentage = (totalValue, partialValue) => ((100 * partialValue) / totalValue);
const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    width: '100%',
    borderRadius: theme.shape.borderRadius,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: theme.palette.greyCustom[theme.palette.mode === 'light' ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
        backgroundColor: theme.palette.mode === 'light' ? theme.palette.tertiary.main : '#308fe8',
    },
}));
const RatingPercentLine = ({ total, current }) => {
    const percentage = calculatePercentage(total, current);
    return (_jsxs(Grid, { container: true, columnSpacing: 1.375, children: [_jsx(Grid, { item: true, xs: 9, sx: { my: 'auto' }, children: _jsx(BorderLinearProgress, { variant: "determinate", value: percentage }) }), _jsx(Grid, { item: true, xs: 3, children: _jsx(Typography, { fontWeight: "fontWeightBold", variant: "caption", children: `${percentage.toFixed(2)}%` }) })] }));
};
export default RatingPercentLine;
//# sourceMappingURL=RatingPercentLine.js.map